import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'
import moment from 'moment'
import Numeral from 'numeral'

//import routeActions from 'actions/routeActions'
import { tenantLedger } from 'selectors/tenant'
import Section from 'components/Section'
import AddButton from '../transactionForm/AddPaymentButton'

import { Column, Table, AutoSizer  } from 'react-virtualized'
import 'react-virtualized/styles.css'
import calcTable from 'utils/calcTable'

let select = (state, props) => ({
	transactions: tenantLedger(state, props)
})


export class Ledger extends Component{
	render(){
		let { props } = this
		let height = (props.transactions.length + 1) * 48
		let cols = {
			date:{min: 50, avg: 150}
		  , type: {min: 45, avg: 150}
		  , amount: 150
		  , balance: 100
		}
		let width = props.width
		cols = calcTable(parseInt(width), cols)
		return(
			<Section
				id="tenant/ledger"
				title="Ledger"
			>
				<Table
					width={parseInt(width)-30}
					height={height}
					headerHeight={48}
					rowHeight={48}
					rowCount={props.transactions.length}
					rowClassName={(x)=>{
						if (x.index == -1) {
							return "tableHeaderClass"
						} else {
							return "tableRowClass"
						}
					}}
					rowStyle={({ index }) => ({
						borderBottom: 'none'
					  , borderTop: index > -1 ? '1px #c8c8c8 solid' : 'none'
					})}
					onRowClick = {() => console.log('hello')/*({ rowData }) => props.NAVIGATE(`transaction/${rowData._id}`)*/}
					rowGetter={({ index }) => props.transactions[index]}
				>
					<Column
						width={cols.date}
						label="date"
						dataKey="date"
						cellRenderer={({ cellData }) => moment(cellData).format("DD MMM YYYY")}
					/>
					<Column
						width={cols.type}
						label="type"
						dataKey="type"
						cellRenderer={({ cellData }) => cellData.split('/')[1].split('-')[1] ? cellData.split('/')[1].split('-')[1] : cellData.split('/')[1].split('-')[0]}
					/>
					<Column
						width={cols.amount}
						label="amount"
						dataKey="amount"
						cellRenderer={({ cellData }) => (
							<div style={{textAlign:"right", paddingRight:"87px"}}>
								{"$ " + Numeral(cellData).format('0,0')}
							</div>
						)}
					/>
					<Column
						width={cols.balance}
						label="balance"
						dataKey="balance"
						cellRenderer={({ cellData }) => (
							<div style={{textAlign:"right", paddingRight:"37px"}}>
								{"$ " + Numeral(cellData).format('0,0')}
							</div>
						)}
					/>
				</Table>

			</Section>
		)
	}
}

export default connect(select)(Ledger)



// WEBPACK FOOTER //
// ./src/routes/landlord/leaseForm/Ledger.js